module.exports = __webpack_public_path__ + "static/media/facebook.e44d4dd6.svg";